import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

export default function Logout() {
  const navigate = useNavigate();
  const { logout } = useAuth()

  useEffect(() => {
    const performLogout = async () => {
      await logout()
      navigate('/login', { replace: true })
    }
    
    performLogout()
  }, [navigate, logout])

  return null;
}
